import { createApp } from 'vue';
import ContentFeatureItems from './ContentFeatureItems.vue';
import 'shared/styles/components/_c-quick-link-block.scss';

const contentFeatureBlock = document.querySelectorAll('[data-feature="content-feature-items"]');

if (contentFeatureBlock.length > 0) {
	contentFeatureBlock.forEach((contentFeatureItems) => {
		const app = createApp({
		name: 'ContentFeatureItemsApp',
		});
		app.component('content-feature-items', ContentFeatureItems);
		app.mount(contentFeatureItems);
	});
	
}
